export const mutations = {
  setNotificacoes(state, data) {
    state.notificacoes = data;
  },
  removeNotificacao(state, item) {
    let indice = state.notificacoes.indexOf(item);
    state.notificacoes.splice(indice, 1);
  },
};

export default {}
